var _style, _path, _path2, _defs, _polygon, _path3, _defs2, _polygon2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChocolate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F8EEE1;}\n\t.st1{fill:#894B38;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#BE694F;}\n\t.st3{fill:#325CA6;}\n\t.st4{clip-path:url(#SVGID_4_);fill:#29384F;}\n\t.st5{fill:#CAD4DB;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.31,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.01,151.25,61.62,185.55,104.31,185.55"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.75,152.78c-4.5,4.5-11.8,4.5-16.31,0h0L56.4,97.74c-4.5-4.5-4.5-7.73,0-12.23l24.46-24.46 c4.5-4.5,7.73-4.5,12.23,0l55.04,55.04c4.5,4.5,4.5,11.81,0,16.31L127.75,152.78z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M80.87,61.05L56.4,85.51c-4.5,4.5-4.5,7.73,0,12.23l55.04,55.04c4.5,4.5,11.8,4.5,16.31,0c0,0,0,0,0,0 l20.38-20.38c4.5-4.51,4.5-11.8,0-16.31L93.1,61.05c-2.25-2.25-4.18-3.38-6.12-3.38C85.05,57.67,83.12,58.8,80.87,61.05"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "144.06,144.62 85.54,86.1 102.44,69.2 98.37,65.12 81.46,82.03 68.63,69.2 64.56,73.28 77.39,86.1  55.56,107.93 59.63,112.01 81.46,90.18 139.98,148.7  "
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M127.75,156.85c-4.5,4.5-11.8,4.5-16.31,0L82.9,128.31c-4.5-4.5-4.5-11.8,0-16.31h0l24.46-24.46 c4.5-4.5,11.8-4.5,16.31,0c0,0,0,0,0,0l28.54,28.54c4.5,4.5,4.5,11.8,0,16.31L127.75,156.85z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M107.36,87.55L82.9,112.01c-4.5,4.5-4.5,11.8,0,16.31h0l28.54,28.54c1.59,1.6,3.62,2.69,5.83,3.14h4.64 c2.21-0.45,4.24-1.54,5.84-3.14l24.46-24.46c4.5-4.51,4.5-11.8,0-16.31l-28.54-28.54c-2.16-2.16-5.1-3.38-8.16-3.38 C112.46,84.17,109.52,85.38,107.36,87.55"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "126.77,85.04 100.83,151.35 83.53,142.7 121.01,82.16  "
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.56,81.43l6.11,6.11c-2.04,6.12-24.46,44.85-28.54,53c0,0-2.04,6.11-7.13,1.02 c-3.58-3.58-10.68-10.67-15.29-15.29c-1.96-1.96-1.97-6.18,0-8.15l36.69-36.69C113.48,77.35,117.56,81.43,117.56,81.43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolate);
export default __webpack_public_path__ + "static/media/Chocolate.2d2785ecba9dfe8fb9cfd7877c8fff6a.svg";
export { ForwardRef as ReactComponent };